/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InventoryPricingPricingStatusEnum = {
    Pending: 'PENDING',
    InQueue: 'IN_QUEUE',
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const InventoryPricingFailureReasonEnum = {
    InvalidAsinMarketplace: 'INVALID_ASIN_MARKETPLACE',
    MissingPayload: 'MISSING_PAYLOAD',
    ApiError: 'API_ERROR',
    RateLimit: 'RATE_LIMIT'
};
/**
 * Check if a given object implements the InventoryPricing interface.
 */
export function instanceOfInventoryPricing(value) {
    return true;
}
export function InventoryPricingFromJSON(json) {
    return InventoryPricingFromJSONTyped(json, false);
}
export function InventoryPricingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'lowestPrice': json['lowestPrice'] == null ? undefined : json['lowestPrice'],
        'buyboxPrice': json['buyboxPrice'] == null ? undefined : json['buyboxPrice'],
        'totalOfferCount': json['totalOfferCount'] == null ? undefined : json['totalOfferCount'],
        'fbaOfferCount': json['fbaOfferCount'] == null ? undefined : json['fbaOfferCount'],
        'fbmOfferCount': json['fbmOfferCount'] == null ? undefined : json['fbmOfferCount'],
        'amazonOfferCount': json['amazonOfferCount'] == null ? undefined : json['amazonOfferCount'],
        'primeOfferCount': json['primeOfferCount'] == null ? undefined : json['primeOfferCount'],
        'targetSellerIds': json['targetSellerIds'] == null ? undefined : json['targetSellerIds'],
        'targetSellerCount': json['targetSellerCount'] == null ? undefined : json['targetSellerCount'],
        'targetResolvedSellerCount': json['targetResolvedSellerCount'] == null ? undefined : json['targetResolvedSellerCount'],
        'targetCnSellerCount': json['targetCnSellerCount'] == null ? undefined : json['targetCnSellerCount'],
        'targetCnShipOfferCount': json['targetCnShipOfferCount'] == null ? undefined : json['targetCnShipOfferCount'],
        'targetSellerOrigin': json['targetSellerOrigin'] == null ? undefined : json['targetSellerOrigin'],
        'targetBrandSeller': json['targetBrandSeller'] == null ? undefined : json['targetBrandSeller'],
        'offerInfoLastModifiedDate': json['offerInfoLastModifiedDate'] == null ? undefined : (new Date(json['offerInfoLastModifiedDate'])),
        'pricingStatus': json['pricingStatus'] == null ? undefined : json['pricingStatus'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'pricingQueuedAt': json['pricingQueuedAt'] == null ? undefined : (new Date(json['pricingQueuedAt'])),
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'marketplaceId': json['marketplaceId'] == null ? undefined : json['marketplaceId'],
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'seller': json['seller'] == null ? undefined : json['seller'],
    };
}
export function InventoryPricingToJSON(json) {
    return InventoryPricingToJSONTyped(json, false);
}
export function InventoryPricingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'lowestPrice': value['lowestPrice'],
        'buyboxPrice': value['buyboxPrice'],
        'totalOfferCount': value['totalOfferCount'],
        'fbaOfferCount': value['fbaOfferCount'],
        'fbmOfferCount': value['fbmOfferCount'],
        'amazonOfferCount': value['amazonOfferCount'],
        'primeOfferCount': value['primeOfferCount'],
        'targetSellerIds': value['targetSellerIds'],
        'targetSellerCount': value['targetSellerCount'],
        'targetResolvedSellerCount': value['targetResolvedSellerCount'],
        'targetCnSellerCount': value['targetCnSellerCount'],
        'targetCnShipOfferCount': value['targetCnShipOfferCount'],
        'targetSellerOrigin': value['targetSellerOrigin'],
        'targetBrandSeller': value['targetBrandSeller'],
        'offerInfoLastModifiedDate': value['offerInfoLastModifiedDate'] == null ? undefined : ((value['offerInfoLastModifiedDate']).toISOString()),
        'pricingStatus': value['pricingStatus'],
        'failureReason': value['failureReason'],
        'pricingQueuedAt': value['pricingQueuedAt'] == null ? undefined : ((value['pricingQueuedAt']).toISOString()),
        'sourceType': value['sourceType'],
        'sourceId': value['sourceId'],
        'asin': value['asin'],
        'marketplaceId': value['marketplaceId'],
        'searchId': value['searchId'],
        'seller': value['seller'],
    };
}
